import { Component, Input, OnInit } from '@angular/core';
import { ReactiveFormsModule, ControlContainer, FormGroupDirective, FormControl } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CheckboxFormFieldComponent } from '../fields/checkbox-form-field/checkbox-form-field.component';
import { DatepickerFormFieldComponent } from '../fields/datepicker-form-field/datepicker-form-field.component';
import { InputFormFieldComponent } from '../fields/input-form-field/input-form-field.component';
import { DropdownTypeEnum } from 'app/shared/enums/dropdowns.enum';
import { ConfigurationSelectFormFieldComponent } from '../fields/configuration-select-form-field/configuration-select-form-field.component';

@Component({
  selector: 'app-case-record-product-company-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputFormFieldComponent,
    DatepickerFormFieldComponent,
    CheckboxFormFieldComponent,
    TranslateModule,
    ConfigurationSelectFormFieldComponent,
  ],
  templateUrl: './case-record-product-company-form.component.html',
  styleUrl: './case-record-product-company-form.component.scss',
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class CaseRecordProductCompanyFormComponent implements OnInit {
  @Input() viewMode!: boolean;

  form: any;
  dropdownSupplierEngagedType = DropdownTypeEnum.SUPPLIER_ENGAGED;
  dropdownDistributedManufacturingPcType = DropdownTypeEnum.DISTRIBUTED_MANUFACTURING_PC;

  ngOnInit(): void {
    this.createForm();
  }

  constructor(
    public mainForm: FormGroupDirective
  ) {}

  createForm() {
    this.form = this.mainForm.form;

    this.form.addControl('id', new FormControl(null, []));
    this.form.addControl('caseId', new FormControl(null, []));
    this.form.addControl('engagePc', new FormControl(false, []));
    this.form.addControl('engagePcDate', new FormControl({ value: null, disabled: true }, []));
    this.form.addControl('supplierEngaged', new FormControl(null, []));
    this.form.addControl('pcAdditionalInfo', new FormControl(null, []));
    this.form.addControl('distributedManufacturingPc', new FormControl(null, []));
  }

}
